import React, { useState, useRef } from "react"

import { MpnLookupRequest } from "../types"

const API = process.env.REACT_APP_API_URL

export const fetchProducts = (search: string, authToken?: string) => {
  
    return fetch(API + `/products?search=${search}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(authToken ? { 'Authorization': `Bearer ${authToken}` } : {})
      }
      
    })
    
  }


export const getContractsForMpnLookup = (lookup: MpnLookupRequest, authToken?: string) => {

    const reqBody = { 
        // vendor, 
        lookups: [lookup]
    }

    console.log('Request Body', reqBody)
  
    return fetch(API + '/mpnlookup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(authToken ? { 'Authorization': `Bearer ${authToken}` } : {})
      },
      body: JSON.stringify(reqBody)
    })
    
  }